export default {"src":"/planos/_next/static/media/instagram-icon.747f7b88.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};